export default "__VITE_ASSET__DTGRK_lN__"